enum TEXTAREA_ROWS {
  MAX = 20,
  MIDDLE = 10,
  MIN = 5,
  MIN_MIN = 2,
}

enum TEXTAREA_ROWS_VALUES {
  MAX = 400,
  MIDDLE = 100,
  MIN = 50,
  MIN_MIN = 2,
}

export function getTextareaRows(values: number) {
  if (values >= TEXTAREA_ROWS_VALUES.MAX) {
    return TEXTAREA_ROWS.MAX;
  } else if (values >= TEXTAREA_ROWS_VALUES.MIDDLE) {
    return TEXTAREA_ROWS.MIDDLE;
  } else if (values >= TEXTAREA_ROWS_VALUES.MIN) {
    return TEXTAREA_ROWS.MIN;
  } else {
    return TEXTAREA_ROWS.MIN_MIN;
  }
}
